module.exports = __webpack_public_path__ + "static/media/travel-prod-info-03.076d1289.png";